import Translate from "i18n/Translate";
import globalState from "globalState";

export default (props) => {
  // here we get the current culture from the global state
  // TODO: add a component to actually set the desired culture
  const state = globalState();
  const culture = state.culture.get();

  // eslint-disable-next-line react/jsx-props-no-spreading
  return Translate({ culture, ...props });
};
